import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('HotelFacilityModel')
export default class HotelFacilityModel {
  @JsonProperty('name', String) public name:string = '';
  @JsonProperty('scope', String) public scope:string = '';
}
